import { Button } from "primereact/button";

interface WizardStepScanProps {
  processing: boolean;
  loading: boolean;
  onScan: () => void;
  onSkipScan: () => void;
}

export function WizardStepScan({
  processing,
  loading,
  onScan,
  onSkipScan,
}: WizardStepScanProps) {
  return (
    <div className="p-fluid">
      <div className="p-field">
        <h3>Scan for Devices</h3>
        <p>
          Click the button below to start searching for nearby Lifeguard
          devices.
        </p>
        <p>
          Make sure your device&apos;s Bluetooth is enabled and that the
          Lifeguard is nearby.
        </p>
        <div style={{ marginTop: "24px" }}>
          <Button
            label="Scan for Devices"
            icon="pi pi-search"
            onClick={onScan}
            disabled={processing || loading}
            className="p-button-primary"
            style={{ width: "100%", marginBottom: "10px" }}
          />
          <Button
            label="Manual Serial Number Entry"
            icon="pi pi-fast-forward"
            onClick={onSkipScan}
            disabled={processing || loading}
            className="p-button-secondary"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}
